import React from 'react'
import IconWrapper, { IconProps } from './IconWrapper'

export const LightbulbIcon = (props: IconProps) => (
    <IconWrapper {...props}>
        <svg
            version="1.1"
            x="0px"
            y="0px"
            width="24px"
            height="24px"
            viewBox="0 0 24 24"
            enableBackground="new 0 0 24 24"
            xmlSpace="preserve"
            aria-hidden="true"
        >
            <path
                fill="currentColor"
                d="M9.97308 18H11v-5h2v5h1.0269c0.132 -1.2016 0.7452 -2.1935 1.7407 -3.2774 0.1121 -0.122 0.8312 -0.8662 0.9165 -0.9725C17.5318 12.6931 18 11.385 18 10c0 -3.31371 -2.6863 -6 -6 -6 -3.31371 0 -6 2.68629 -6 6 0 1.3843 0.46774 2.6917 1.31462 3.7484 0.08542 0.1066 0.80619 0.8528 0.91692 0.9734 0.99612 1.0846 1.60949 2.0766 1.74154 3.2782ZM10 20v1h4v-1h-4Zm-4.24605 -5.0008C4.65645 13.6297 4 11.8915 4 10c0 -4.41828 3.58172 -8 8 -8 4.4183 0 8 3.58172 8 8 0 1.8925 -0.6572 3.6315 -1.7557 5.0014C17.624 15.7748 16 17 16 18.5V21c0 1.1046 -0.8954 2 -2 2h-4c-1.10457 0 -2 -0.8954 -2 -2v-2.5c0 -1.5 -1.62542 -2.7264 -2.24605 -3.5008Z"
            />
        </svg>
    </IconWrapper>
)
